import { mapState } from 'vuex'

export default {
  props: {
    boardId: { type: String, required: true }
  },
  data () {
    return {
      board: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    this.search()
  },
  computed: {
    ...mapState(['user', 'boardMetas']),
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    },
    boardMeta () {
      return this.boardMetas[this.boardId]
    },
    // boardName () {
    //   return this.boardMeta.boardName
    // },
    useOptions () {
      return this.boardMeta.useOptions
    },
    theme () {
      const mode = this.isAdminMode ? 'admin' : 'user'
      const { theme } = this.boardMeta
      if (theme.hasOwnProperty(mode)) {
        return theme[mode]
      }
      return {
        list: { type: 'table' }
      }
    }
  },
  methods: {
    async search (limit = 5) {
      try {
        const params = {
          limit
        }

        const res = await this.$http.get(`/api/boards/${this.boardId}`, { params })
        console.log(res.data)
        this.board = res.data
      } catch (ex) {
        console.log(ex)
      } finally {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      }
    },
    goView (seq) {
      this.$router.push({
        name: !this.isAdminMode ? 'boardView' : 'adminBoardEdit',
        params: { boardId: this.boardId, seq }
      })
    }
  }
}
